import { useState, useCallback } from 'react';
import axios from 'axios';
import { Wallpaper } from '../../components/Wallpaper';
import { ErrorPage } from '../ErrorPage';
import { isMobile } from '../../utils/utils';
import { QRCodeSVG } from 'qrcode.react';
import { CollectImageTitle } from '../PersonalDocument/styles';
import { Logo } from '../../components';
import { Footer } from '../../components/Footer';
import { Box } from '@mui/material';
import { WebFaceReconSDK } from '../../sdks/WebFaceReconSDK';

export const FaceRecognitionBatch = (props) => {
    const {
        signBatchData,
        setSignerBatchStep,
        setSignBatchData,
        clientThemeSettings,
        signerBatchHash,
    } = props;

    const [error, setError] = useState({ has_error: false, status: 0 });

    const getClientSessionKey = useCallback(async () => {
        if (!signBatchData.signer_token) {
            setError({ has_error: true, status: 401 });
            return null;
        }
        try {
            const config = { headers: { Authorization: signBatchData.signer_token } };
            const response = await axios.get('signer_batch/liveness_client_session_key', config);
            const clientSessionKey = response.data.client_session_key;
            if (!clientSessionKey) throw new Error("Response does not contain 'client_session_key'.");
            return clientSessionKey;
        } catch (err) {
            const status = err.response?.status;
            setError({ has_error: true, status: [401, 403, 409].includes(status) ? status : 500 });
            return null;
        }
    }, [signBatchData.signer_token]);

    const handleSuccess = useCallback((imageKey) => {
        const payload = { event_date: new Date().toISOString(), image_key: imageKey, step: 'face_recognition' };
        const config = { headers: { Authorization: signBatchData.signer_token } };

        axios.patch('/signer_batch', payload, config)
            .then(response => {
                setSignBatchData({ ...signBatchData, ...response.data });
                setSignerBatchStep(response.data.next_step);
            })
            .catch(err => {
                const status = err.response?.status;
                setError({ has_error: true, status: [401, 403, 409].includes(status) ? status : 500 });
            });
    }, [signBatchData, setSignBatchData, setSignerBatchStep]);

    const qrCodeUrl = signBatchData.signer_batch_data?.birthdate
        ? `${window.location.href}?document_number=${signBatchData.signer_batch_data.document_number}&birthdate=${signBatchData.signer_batch_data.birthdate?.split('-').reverse().join('-')}`
        : `${window.location.href}?document_number=${signBatchData.signer_batch_data.document_number}`;

    if (!isMobile()) {
        return (
            <Wallpaper backgroundColor={clientThemeSettings['background_color']} style={{ padding: '10px' }}>
                <div className="base-container base-container-width base-container-padding" style={{ backgroundColor: 'rgb(245, 245, 242)' }}>
                    <Logo imageSource={clientThemeSettings.logo_url} />
                    <Box>
                        <CollectImageTitle>
                            Agora precisamos realizar a prova de vida. Escaneie o QR Code abaixo para continuar a jornada pelo seu dispositivo móvel.
                        </CollectImageTitle>
                        <div style={{ display: 'flex' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-evenly', width: '100%', height: '100%' }}>
                                <QRCodeSVG value={qrCodeUrl} width={'70%'} height={'70%'} />
                            </div>
                        </div>
                    </Box>
                    <Footer />
                </div>
            </Wallpaper>
        );
    }

    return (
        <>
            <WebFaceReconSDK
                sessionId={signerBatchHash}
                clientThemeSettings={clientThemeSettings}
                showBackButton={false}
                getToken={getClientSessionKey}
                onSuccess={handleSuccess}
                onUserCanceled={() => setSignerBatchStep('document_display')}
                onError={(status) => setError({ has_error: true, status })}
            />
            {error.has_error && (
                <ErrorPage
                    error={error}
                    redirectToLogin={() => setSignerBatchStep('login')}
                    resetError={() => setError({ has_error: false, status: 0 })}
                    clientThemeSettings={clientThemeSettings}
                />
            )}
        </>
    );
};
